export default [
  {
    path: '/app/seguridad/sistemas',
    name: 'rt-seguridad-sistemas',
    component: () => import('@/views/palmas/seguridad/sistema/Sistema.vue'),
    meta: {
      pageTitle: 'Sistemas',
      breadcrumb: [
        {
          text: 'Seguridad',
        },
        {
          text: 'Sistemas',
          active: true,
        },
      ],
    },
  },
  {
    path: '/app/seguridad/usuarios',
    name: 'rt-seguridad-usuarios',
    component: () => import('@/views/palmas/seguridad/usuario/UsuarioList.vue'),
    meta: {
      pageTitle: 'Usuarios',
      breadcrumb: [
        {
          text: 'Seguridad',
        },
        {
          text: 'Usuarios',
          active: true,
        },
      ],
    },
  },
]
